<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card text-left">
					<div class="card-header">
						Rechazar versión
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="card-body">
						<h4>Rechazar esta versión</h4>
						<div>
							Estás a punto de rechazar esta versión en este momento de su producción.
							Por favor rellena el formulario y sé lo más explícito posible para que se entienda
							bien el motivo del rechazo y evitemos que se repita en la nueva versión
						</div>
						<div class="form-group">
							<label for="">Motivos</label>
							<textarea name="" rows="10" class="form-control form-control-sm" v-model="form.descripcion" placeholder="Explica aquí los motivos"></textarea>
						</div>
						<div class="row">
							<div class="col">
								<div class="card">
									<div class="card-header bg-danger text-white">
										Motivos del anunciante
									</div>
									<div class="card-body bg-light">
										<div class="mt-1 input-group input-group-sm" v-for="motivo in motivos.cliente" :key="motivo.ID_motivo">
											<div class="input-group-btn">
												<button class="btn btn-sm" :class="(esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default'" @click="toggleMotivo(motivo.ID_motivo)">
													<span class="fa fa-check"></span>
												</button>
											</div>
											<div class="form-control form-control-sm">
												{{motivo.titulo}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col">
								<div class="card">
									<div class="card-header bg-warning text-dark">
										{{motivosDeQuien}}
									</div>
									<div class="card-body bg-light">
										<div class="mt-1 input-group input-group-sm" v-for="motivo in motivos.agente" :key="motivo.ID_motivo" v-if="tarea.fase.match(/(pteAprobarIdea|pteAprobarProduccion)/)">
											<div class="input-group-prepend">
												<button class="btn btn-sm" :class="(esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default'" @click="toggleMotivo(motivo.ID_motivo)">
													<span class="fa fa-check"></span>
												</button>
											</div>
											<div class="form-control form-control-sm">
												{{motivo.titulo}}
											</div>
										</div>

										<div class="mt-1 input-group input-group-sm" v-for="motivo in motivos.marketing" :key="motivo.ID_motivo" v-if="tarea.fase.match(/(pteIdea)/)">
											<div class="input-group-prepend">
												<button class="btn btn-sm" :class="(esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default'" @click="toggleMotivo(motivo.ID_motivo)">
													<span class="fa fa-check"></span>
												</button>
											</div>
											<div class="form-control form-control-sm">
												{{motivo.titulo}}
											</div>
										</div>

										<div class="mt-1 input-group input-group-sm" v-for="motivo in motivos.tecnico" :key="motivo.ID_motivo" v-if="tarea.fase ==='pteProduccion'">
											<div class="input-group-prepend">
												<button class="btn btn-sm" :class="(esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default'" @click="toggleMotivo(motivo.ID_motivo)">
													<span class="fa fa-check"></span>
												</button>
											</div>
											<div class="form-control form-control-sm">
												{{motivo.titulo}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group mt-2" v-if="tarea.fase === 'pteAprobarProduccion'">
							<label class="font-weight-bold">¿Es necesario cambiar el texto?</label>
							<br>
							<div class="btn-group">
								<button class="btn btn-sm" :class="(form.cambiaTexto) ? 'btn-primary' : 'btn-default'" @click="form.cambiaTexto = true">
									Sí
								</button>
								<button class="btn btn-sm" :class="(!form.cambiaTexto) ? 'btn-primary' : 'btn-default'" @click="form.cambiaTexto = false">
									No
								</button>
							</div>
						</div>
					</div>

					<div class="card-footer">
						<button class="btn btn-sm btn-primary" @click="doRechazar()">Rechazar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import API from '../../services/api'

export default {
	name: 'rechazo-tarea',
	props: ['tarea', 'version'],
	data: function () {
		return {
			form: {
				ID_version: null,
				cambiaTexto: true,
				descripcion: '',
				motivos: []
			},
			motivos: {
				'cliente': [],
				'agente': [],
				'marketing': [],
				'tecnico': []
			}
		}
	},

	created () {
		// Obtenemos los motivos de rechazo
		this.form.ID_version = this.version.ID_version

		API.getMotivosRechazo()
			.then(res => {
				this.motivos = res.data.motivos
			})
			.catch(e => {
				this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	computed: {
		motivosDeQuien () {
			if (this.tarea.fase.match(/pteAprobar/)) {
				return 'Motivos del agente'
			} else if (this.tarea.fase === 'pteIdea') {
				return 'Motivos de márketing'
			} else if (this.tarea.fase === 'pteProduccion') {
				return 'Motivos de técnica'
			} else {
				return ''
			}
		}
	},

	methods: {
		toggleMotivo (motivo) {
			const i = this.form.motivos.indexOf(motivo)
			if (i >= 0) {
				this.form.motivos.splice(i, 1)
			} else {
				this.form.motivos.push(motivo)
			}
		},
		esMotivo (motivo) {
			return (this.form.motivos.indexOf(motivo) >= 0)
		},
		doRechazar () {
			API.setRechazarVersion(this.form)
				.then(res => {
					// Se ha rechazado correctamente, recibimos la nueva versión
					this.$emit('nueva', res.data.version)
					this.cerrar()
					this.$store.commit('toast/success', {
						titulo: 'Tarea rechazada',
						mensaje: 'Se ha rechazado la tarea correctamente'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/rechazo-tarea.vue